/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Ws_Plan_NInputs */

const en_ws_plan_n = /** @type {(inputs: Ws_Plan_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PLAN #${i?.n}`)
};

const id_ws_plan_n = /** @type {(inputs: Ws_Plan_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`RENCANA #${i?.n}`)
};

/**
* | output |
* | --- |
* | "PLAN #{n}" |
*
* @param {Ws_Plan_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_plan_n = /** @type {((inputs: Ws_Plan_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Plan_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_plan_n(inputs)
	return en_ws_plan_n(inputs)
});